<template>
  <form @submit.prevent="onSubmit">
    <users-select-list
      label="Исполнитель"
      v-model="selectedUser"
      :users="users"
      :isLoading="!users"
      :isLoaded="!!users"
      :danger.sync="error"
      :danger-text="error"
    />

    <div class="text-center mt-4">
      <app-button>Назначить исполнителя</app-button>
    </div>
  </form>
</template>

<script>
import UsersSelectList from "@/components/common/UsersSelectList";
import modalContext    from "@/mixins/modalContext";
import notifyHttpError from "@/mixins/notifyHttpError";

export default {
  name:       "IssueChangeManagerModal",
  mixins:     [modalContext, notifyHttpError],
  components: { UsersSelectList },
  props:      ['issue', 'onChangeManager'],
  data() {
    return {
      users:        null,
      selectedUser: null,
      error:        null,
      isProgress:   false,
    };
  },
  methods:    {
    onSelectUser( user ) {
      this.selectedUser = user.id;
    },

    onSubmit() {
      if (this.isProgress) return;
      this.error = this.selectedUser ? null : 'Выберите исполнителя';
      if (this.error) return;

      this.isProgress = true;
      this.onChangeManager(this.selectedUser).then(
        () => this.modalResolve(),
        this.notifyHttpError,
      ).finally(() => this.isProgress = false);
    },

    loadUsers() {
      const { buildings_id } = this.issue;
      const params = { buildings_id };
      this.$http.get(`permission_houses/${buildings_id}`, { params })
        .then(( { data } ) => this.users = data);
    },
  },
  mounted() {
    this.loadUsers();
    this.selectedUser = this.issue.performer_id;
  },
};
</script>

<style lang="scss" module>
</style>
